import { render, staticRenderFns } from "./AppChatBubble.vue?vue&type=template&id=42d32f03&scoped=true&"
import script from "./AppChatBubble.vue?vue&type=script&lang=ts&"
export * from "./AppChatBubble.vue?vue&type=script&lang=ts&"
import style0 from "./AppChatBubble.vue?vue&type=style&index=0&id=42d32f03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d32f03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VImg})
